import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFullImageUrl } from 'client/utils/image-helpers';
import { IMAGE_SIZES } from 'site-modules/shared/constants/editorial/editorial';
import { ArticleTitle } from 'site-modules/shared/components/editorial/article-title/article-title';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';

import './article-hero-photo.scss';

export function getHeroImageUrl({ href, isMobile }) {
  return getFullImageUrl(href, isMobile ? IMAGE_SIZES.sm_md : IMAGE_SIZES.max);
}

function ArticleHeroPhotoUI({ title, subtitle, photo: { href }, isMobile }) {
  if (!href) {
    return null;
  }

  const hasOverlay = !!(title || subtitle);
  const imageUri = getHeroImageUrl({ href, isMobile });

  return (
    <div className="article-hero-photo-container pos-r d-flex align-items-center">
      <AspectRatioContainer aspectRatio="3:2" className="w-100">
        <img className="photo" alt="" src={imageUri} />
      </AspectRatioContainer>
      {hasOverlay && (
        <div className="article-hero-title-wrapper w-100 h-100 d-flex align-items-start">
          <ArticleTitle title={title} subtitle={subtitle} />
        </div>
      )}
    </div>
  );
}

ArticleHeroPhotoUI.propTypes = {
  photo: PropTypes.shape({
    href: PropTypes.string,
  }).isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  isMobile: PropTypes.bool,
};

ArticleHeroPhotoUI.defaultProps = {
  title: null,
  subtitle: null,
  isMobile: false,
};

export const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const ArticleHeroPhoto = connect(mapStateToProps)(ArticleHeroPhotoUI);
